import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import InputField from './InputField';
import Button from './Button';
import UnverifiedAccountModal from './UnverifiedAccountModal';
import { LockIcon, MailIcon, UserIcon, GlobeIcon } from 'lucide-react';
const RegisterPage = ({
  isEmailRegistered,
  isEmailVerified,
  setCurrentEmail
}) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    country: '',
    termsAccepted: false
  });
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCheckboxChange = e => {
    setFormData(prev => ({
      ...prev,
      termsAccepted: e.target.checked
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.password || !formData.confirmPassword || !formData.country) {
      setError('Please fill in all fields');
      return;
    }
    if (!formData.termsAccepted) {
      setError('You must agree to the terms of service');
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (isEmailRegistered(formData.email)) {
      if (!isEmailVerified(formData.email)) {
        setCurrentEmail(formData.email);
        setShowModal(true);
      } else {
        setError('This email is already registered');
      }
      return;
    }
    alert('Registration successful! Please verify your email.');
    setCurrentEmail(formData.email);
    navigate('/verify');
  };
  const handleVerifyAccount = () => {
    setShowModal(false);
    navigate('/verify');
  };
  const navigateToLogin = () => {
    navigate('/');
  };
  return <AuthLayout title="Create Account" data-id="element-155">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-156">
        {error && <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-lg" data-id="element-157">
            <div className="flex" data-id="element-158">
              <div className="flex-shrink-0" data-id="element-159">
                <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-160">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" data-id="element-161" />
                </svg>
              </div>
              <div className="ml-3" data-id="element-162">
                <p className="text-sm text-red-700" data-id="element-163">{error}</p>
              </div>
            </div>
          </div>}

        <div className="space-y-5" data-id="element-164">
          <div className="relative" data-id="element-165">
            <InputField label="Full name" type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your name" data-id="element-166" />
            <div className="absolute right-4 top-3.5" data-id="element-167">
              <UserIcon size={20} className="text-blue-400" data-id="element-168" />
            </div>
          </div>

          <div className="relative" data-id="element-169">
            <InputField label="Email address" type="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" data-id="element-170" />
            <div className="absolute right-4 top-3.5" data-id="element-171">
              <MailIcon size={20} className="text-blue-400" data-id="element-172" />
            </div>
          </div>

          <div className="relative" data-id="element-173">
            <InputField label="Password" type="password" name="password" value={formData.password} onChange={handleChange} placeholder="********" data-id="element-174" />
            <div className="absolute right-4 top-3.5" data-id="element-175">
              <LockIcon size={20} className="text-blue-400" data-id="element-176" />
            </div>
          </div>

          <div className="relative" data-id="element-177">
            <InputField label="Confirm password" type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="********" data-id="element-178" />
            <div className="absolute right-4 top-3.5" data-id="element-179">
              <LockIcon size={20} className="text-blue-400" data-id="element-180" />
            </div>
          </div>

          <div className="relative" data-id="element-181">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-182">
              Country
            </label>
            <div className="relative" data-id="element-183">
              <select name="country" value={formData.country} onChange={handleChange} className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none bg-white" data-id="element-184">
                <option value="" data-id="element-185">Select your country</option>
                <option value="US" data-id="element-186">United States</option>
                <option value="GB" data-id="element-187">United Kingdom</option>
                <option value="CA" data-id="element-188">Canada</option>
                <option value="AU" data-id="element-189">Australia</option>
                <option value="DE" data-id="element-190">Germany</option>
                <option value="FR" data-id="element-191">France</option>
                <option value="ES" data-id="element-192">Spain</option>
                <option value="IT" data-id="element-193">Italy</option>
                <option value="MX" data-id="element-194">Mexico</option>
                <option value="BR" data-id="element-195">Brazil</option>
                <option value="AR" data-id="element-196">Argentina</option>
                <option value="CL" data-id="element-197">Chile</option>
                <option value="CO" data-id="element-198">Colombia</option>
                <option value="PE" data-id="element-199">Peru</option>
                <option value="JP" data-id="element-200">Japan</option>
                <option value="CN" data-id="element-201">China</option>
                <option value="IN" data-id="element-202">India</option>
                <option value="OTHER" data-id="element-203">Other</option>
              </select>
              <div className="absolute right-4 top-3.5 pointer-events-none" data-id="element-204">
                <GlobeIcon size={20} className="text-blue-400" data-id="element-205" />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center py-4" data-id="element-206">
          <div className="bg-gray-100 border border-gray-300 rounded-lg p-4 w-full max-w-sm" data-id="element-207">
            <div className="flex items-center space-x-3" data-id="element-208">
              <input type="checkbox" className="w-6 h-6 rounded border-gray-300" data-id="element-209" />
              <span className="text-sm text-gray-700" data-id="element-210">I'm not a robot</span>
              <div className="ml-auto" data-id="element-211">
                <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%234285f4'%3E%3Cpath d='M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0zm.25 5l4.5 2.26v4.48L12.25 14 7.75 11.74V7.26L12.25 5zM12 6.5L8.5 8.25v3.5L12 13.5l3.5-1.75v-3.5L12 6.5z'/%3E%3C/svg%3E" alt="reCAPTCHA" className="w-8 h-8" data-id="element-212" />
              </div>
            </div>
            <div className="text-xs text-gray-500 mt-2" data-id="element-213">
              <a href="#" className="text-blue-600 hover:underline" data-id="element-214">
                Privacy
              </a>{' '}
              -{' '}
              <a href="#" className="text-blue-600 hover:underline" data-id="element-215">
                Terms
              </a>
            </div>
          </div>
        </div>

        <div className="flex items-start space-x-3 p-4 bg-gray-50 rounded-lg" data-id="element-216">
          <input type="checkbox" id="terms" checked={formData.termsAccepted} onChange={handleCheckboxChange} className="w-5 h-5 mt-0.5 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-217" />
          <label htmlFor="terms" className="text-sm text-gray-700" data-id="element-218">
            I agree to all statements in{' '}
            <a href="#" className="text-blue-600 hover:text-blue-800 font-medium" data-id="element-219">
              Terms of Service
            </a>
          </label>
        </div>

        <div className="pt-3" data-id="element-220">
          <Button type="submit" fullWidth data-id="element-221">
            Sign Up
          </Button>
        </div>

        <div className="text-center mt-6" data-id="element-222">
          <p className="text-base text-gray-600" data-id="element-223">
            Already have an account?{' '}
            <button type="button" onClick={navigateToLogin} className="font-medium text-blue-600 hover:text-blue-800" data-id="element-224">
              Sign in
            </button>
          </p>
        </div>
      </form>

      {showModal && <UnverifiedAccountModal email={formData.email} onVerify={handleVerifyAccount} onClose={() => setShowModal(false)} data-id="element-225" />}
    </AuthLayout>;
};
export default RegisterPage;